import './networkEthernetApp.css';

import { cssColors, defineCss, messageBox } from '@src/style/style';
import { makeButton } from './networkHelpers.js';
import MachineMotionApi from '@lib/networkApi.js';

// NOTE: in some rare custom setup this IP might be different,
// FUTURE: we could add a `pendantIp` to the `3100/v1/configure/config_info` route to make it easier to configure/update,
// FUTURE: it could be taken from the IP of the PENDANT interface
const PENDANT_IP = '192.168.5.1';

function showConfirmationModal (pTitle, pSubTitle, pYesMessage, pOnConfirm, pOnCancel) {
  const lModalContainer = $('<div>')
    .addClass('ml_modal_container ethernet_confirmation_modal')
    .append(
      $('<div>', { class: 'ml_modal ml_confirmation_modal' }).append(
        // header
        $('<div>').append(
          // title, subtitle, close
          $('<div>').text(pTitle),
          $('<div>').text(pSubTitle),
          $('<div>', { class: 'icon-close' }).css({ padding: '5px 0px' }).click(() => { pOnCancel(); lModalContainer.remove(); }),
        ),
        // footer
        $('<div>').append(
          $('<button>').text('Cancel').click(function () { pOnCancel(); lModalContainer.remove(); }),
          $('<button>').text(pYesMessage).click(function () { pOnConfirm(); lModalContainer.remove(); }),
        ),
      ),
    );

  lModalContainer.appendTo('body');
}

/* Function to check that an address has a valid ipv4 format */
function isValidIpv4Addr (ip) {
  return /^(?=\d+\.\d+\.\d+\.\d+$)(?:(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[0-9]|[0-9]{2})\.?){4}$/.test(ip);
}

/* Function to check that a valid ipv4 address is not link local */
function isNotLinkLocal (ip) {
  return !ip.startsWith('169.254');
}

/* Function to discard unecessary zeros in ipv4 address (to avoid ifconfig dysfunction) */
function reformat (ip) {
  // Split ipv4 address in 4
  const ip_split = ip.split('.');
  // Convert string to number then back to string
  ip_split[0] = Number(ip_split[0]).toString();
  ip_split[1] = Number(ip_split[1]).toString();
  ip_split[2] = Number(ip_split[2]).toString();
  ip_split[3] = Number(ip_split[3]).toString();
  // Merge the 4 strings to one ipv4 address again
  const new_ip = ip_split.join('.');
  return new_ip;
}

const networkApp = {
  rightPane: null,
  uiLeft: null,
  uiRight: null,
  collapsed: true,
  apps: null,
  name: 'Ethernet Settings',
  selectedOption: null,
  options: {
    LAN_1: { data: { ip: null, netmask: null }, buttonUi: null },
    LAN_2: { data: { ip: null, netmask: null }, buttonUi: null },
    GATEWAY: { data: { gateway: null }, buttonUi: null },
  },
  autoMode: 'manual',

  /* this function should be overwritten on init,
    it is a way for the Ethernet app to be aware of the Wifi, but without being coupled to it */
  connectedToWifi: function () { return false; },

  selectOption: function (pOption) {
    this.uiLeft.find('.app-option').removeClass('selected');
    this.options[pOption].buttonUi.addClass('selected');
    this.selectedOption = pOption;
    this.apps.select(this.name);
    this.show();
  },

  setMachineMotionGateway: function (gateway) {
    const lConfiguration = {};
    // check that ipv4 addresses are correct
    if (gateway == '' || (isValidIpv4Addr(gateway) && isNotLinkLocal(gateway))) {
      lConfiguration.machineGateway = reformat(gateway);
    }
    else {
      messageBox('Please enter valid ipv4 gateway', 'warning');
      return;
    }

    function lCallback () { messageBox('Applied network changes', 'info'); }
    function lOnError () { messageBox('Error while configuring network', 'error'); }

    MachineMotionApi.configGateway(lConfiguration, lCallback, lOnError);
  },

  setMachineMotionIP: function (lan, mode, ip, netmask) {
    const lConfiguration = {
      machinePort: lan,
      mode,
      machineIp: '192.168.0.2', // Dummy ip
      machineNetmask: '255.255.255.0', // Dummy netmask
      machineGateway: '192.168.0.1', // Dummy gateway
    };

    if (mode == 'static') {
      // check that ipv4 addresses are correct
      if (isValidIpv4Addr(ip) && isValidIpv4Addr(netmask)) {
        if (isNotLinkLocal(ip)) {
          lConfiguration.machineIp = reformat(ip);
          lConfiguration.machineNetmask = reformat(netmask);
        }
        // given ipv4 addresses were link-local addresses
        else {
          messageBox('Please do not enter link-local addresses', 'warning');
          return;
        }
      }
      // given ipv4 addresses were not correct
      else {
        messageBox('Please enter valid ipv4 addresses', 'warning');
        return;
      }
    }

    function lCallback () {
      // Note Audrey : Not displaying success toaster as proper validation does not yet exist server side. Waiting on ticket VentionCo/mm-vention-control#1605
      // messageBox("Applied network changes", "info");
    }
    function lOnError () {
      messageBox('Error while configuring network', 'error');
    }
    MachineMotionApi.configIp(lConfiguration, lCallback, lOnError);
    messageBox('Requested network changes', 'info');
  },

  makeRightUI: function (pOption) {
    defineCss('.networks-input', 'box-sizing: border-box');
    defineCss('.networks-input > div', 'margin-bottom: 10px; font-weight: 700;');
    defineCss('.networks-input > input', `border: 1px solid ${cssColors.border_color}; border-radius: 3px; box-shadow: none; width:100%; padding-right: 1rem; box-sizing: border-box;`);
    defineCss('.networks-input input:disabled', 'background-color: #E2E2E2;');

    defineCss('.networks-button', 'background-color: #FFFFFF; font-size: 17px; border: 1px solid #9FA9B9; padding: 5px 15px;');
    defineCss('.networks-button.left', 'border-radius: 3px 0px 0px 3px');
    defineCss('.networks-button.right', 'border-radius: 0px 3px 3px 0px');
    defineCss('.networks-button.selected', 'border-radius: 0px 3px 3px 0px; background-color: #EFF2F7;');

    defineCss('.app-right-top', 'padding-bottom: 20px; align-self:center;');

    const lThis = this;

    let fields = [];
    switch (pOption) {
      case 'LAN_1':
      case 'LAN_2': fields = ['ip', 'netmask']; break;
      case 'GATEWAY': fields = ['gateway']; break;
      default: break;
    }

    const ui = $('<div class="app-right app-right-card-container">');

    /* UI for the AUTO/MANUAL setup, is currently canceled, but will be back
        // 1. Auto/Manual toggle switch
        if(pOption != 'GATEWAY') {
            ui.append(
                $('<div class="app-right-top">').append(
                    $('<button class="networks-button left network-bold">').text('Auto Setup').click(function() {
                        MachineMotionApi.setAutoSetupMode('auto', ()=> { lThis.update('onAutoSetupMode', 'auto'); });
                    }),
                    $('<button class="networks-button right network-bold">').text('Manual Setup').click(function() {
                        MachineMotionApi.setAutoSetupMode('manual', ()=> { lThis.update('onAutoSetupMode', 'manual')});
                    }),
                )
            )
        }
        */

    function capitalizeFirstLetter (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

    // 2. Input fields for ip, netmask, gateway
    ui.append(
      $('<div class="app-right app-right-card-inner">').append(
        $('<div class="network-bold center-column bigger">').text('Current Network Settings'),
        $('<div class="network-bold center-column">').text(pOption.replace(/_/, ' ')),
        ...fields.map((field) => {
          const optionValue = this.options[pOption].data[field];
          // grey out and make not editable (loading...). while we havent yet received a response from the server
          // if not available, use a placeholder
          let fieldElement;
          if (optionValue === null) { fieldElement = $(`<input type="tel" id="network_${field}" class="network-input keyboard" placeholder="loading..." disabled style="cursor: default;">`); }
          else if (optionValue === 'unavailable') { fieldElement = $(`<input type="tel" id="network_${field}" class="network-input keyboard" placeholder="unavailable" >`); }
          else { fieldElement = $(`<input type="tel" id="network_${field}" class="network-input keyboard">`).val(optionValue); }

          return $('<div class="networks-input">').append(
            $('<div >').text(field === 'ip' ? 'IP:' : capitalizeFirstLetter(field + ':')),
            fieldElement,
          );
        }),
      ),
    );

    // 3. Buttons to set gateway/ip as needed
    if (pOption == 'GATEWAY') {
      ui.find('.app-right-card-inner').append(
        $('<button class="blue-button">')
          .css({ 'margin-top': '1rem' })
          .text('Configure Gateway')
          .click(function () {
            const newGateway = ui.find('#network_gateway').val();
            // in we are connected to wifi, warn the user that changing the gateway to the pendant could lead to connectivity loss
            if (lThis.connectedToWifi() && newGateway != PENDANT_IP && lThis.options.GATEWAY.data.gateway == PENDANT_IP) {
              showConfirmationModal(
                'Change gateway?', 'This will make you lose WiFi connectivity.', 'Yes, change gateway',
                function () { lThis.setMachineMotionGateway(newGateway); },
                function () { ui.find('input.network-input').val(lThis.options.GATEWAY.data.gateway); },
              );
            }
            else {
              lThis.setMachineMotionGateway(newGateway);
            }
          }),
      );
    }
    else {
      const lAddButtons = true;
      // auto/manual mode, and disable inputs if needed
      /*
            switch(lThis.autoMode) {
                case 'auto':
                    ui.find('button.left').addClass('selected');
                    if(pOption == 'LAN_2') {
                        ui.find('input').attr('disabled', true);
                        lAddButtons = false;
                    }
                    break;
                case 'manual':
                    ui.find('button.right').addClass('selected');
                    break;
                default: break;
            }
            */

      if (lAddButtons) {
        ui.find('.app-right-card-inner').append(
          $('<button class="green-button">')
            .css({ 'margin-top': '1rem' })
            .text('Use Static Mode')
            .click(function () {
              const networkIp = ui.find('#network_ip').val();
              // in we are connected to wifi, warn the user that changing the gateway to the pendant could lead to connectivity loss
              if (lThis.connectedToWifi() && networkIp == PENDANT_IP) {
                showConfirmationModal(
                  "Change IP to Pendant's IP?", 'This will make you lose WiFi connectivity.', 'Yes, change IP',
                  function () { lThis.setMachineMotionIP(pOption, 'static', networkIp, ui.find('#network_netmask').val()); },
                  function () {
                    ui.find('#network_ip').val(lThis.options[pOption].data.ip);
                    ui.find('#network_netmask').val(lThis.options[pOption].data.netmask);
                  },
                );
              }
              else {
                lThis.setMachineMotionIP(pOption, 'static', networkIp, ui.find('#network_netmask').val());
              }
            }),
          $('<button class="red-button">')
            .text('Use Dynamic Mode')
            .click(function () { lThis.setMachineMotionIP(pOption, 'dhcp', undefined, undefined); }),
        );
      }
    }

    return ui;
  },

  makeLeftUI: function () {
    const lThis = this;
    const uiOptions = [];
    Object.keys(this.options).forEach(function (pOption) {
      const lOption = $('<div class="app-option">').append(
        $('<div class="app-option-selector">').css({ height: '100%' }),
        $('<span>').text(pOption.replace(/_/, ' ')).css({ padding: '10px', 'font-weight': 700 }),
        $('<i class="fal fa-network-wired app-option-icon">').css({ 'font-size': '1.5rem' }),
      );
      lOption.click(function () { lThis.selectOption(pOption); });
      uiOptions.push(lOption);
      lThis.options[pOption].buttonUi = lOption;
    });

    const ui = makeButton(this.name, true);
    ui.find('.app-options').css({ display: 'none' }).append(uiOptions);

    return ui;
  },

  init: function (pLeft, pRight, pApps, callbacksMap) {
    this.rightPane = pRight;
    this.apps = pApps;

    this.connectedToWifi = callbacksMap.isConnected || this.connectedToWifi; // connectedToWifi is a function

    this.uiLeft = this.makeLeftUI();
    this.uiLeft.find('.app-button-title').click(() => { this.collapse(); });
    pLeft.append(this.uiLeft);
  },

  show: function () {
    if (!this.selectedOption) { return; }

    this.rightPane.empty();
    this.uiRight = this.makeRightUI(this.selectedOption);
    this.rightPane.append(this.uiRight);
  },

  _remove: function () {
    if (this.uiRight) {
      this.uiRight.remove();
      this.uiRight = null;
    }
  },

  select: function () {
    this.uiLeft.find('.app-button-title').addClass('selected');
    this.uiLeft.addClass('selected');
  },

  deselect: function () {
    this._remove();
    this.selectedOption = null;
    this.uiLeft.removeClass('selected');
    this.uiLeft.find('.app-button-title').removeClass('selected');
    this.uiLeft.find('.app-option').removeClass('selected');
  },

  collapse: function () {
    this.collapsed = !this.collapsed;
    this.uiLeft.find('.app-options').css({ display: this.collapsed ? 'none' : 'flex' });

    if (this.collapsed) {
      this.uiLeft.find('.app-button-title').removeClass('expanded');
      this.uiLeft.find('.app-button-title > span').removeClass('fa-chevron-up').addClass('fa-chevron-down');
    }
    else {
      this.uiLeft.find('.app-button-title').addClass('expanded');
      this.uiLeft.find('.app-button-title > span').removeClass('fa-chevron-down').addClass('fa-chevron-up');
    }
  },

  update: function (pType, pData) {
    let needUpdate = false;

    switch (pType) {
      /* For Auto Setup, not used for now
            case 'onAutoSetupMode':
                if(pData != this.autoMode) {
                    needUpdate = true;
                    this.autoMode = pData;
                }
                break;
            */
      case 'LAN_1':
      case 'LAN_2': {
        const pNetwork = pType;
        const editing = this.uiRight && this.uiRight.find('input').is(':focus');

        if (pData.ip == -1) {
          pData.ip = 'unavailable';
        }
        if (pData.netmask == -1) {
          pData.netmask = 'unavailable';
        }
        if (pData.gateway == -1) {
          pData.gateway = 'unavailable';
        }

        if (this.options[pNetwork].data.ip != pData.ip) {
          this.options[pNetwork].data.ip = pData.ip;
          needUpdate = true;
        }

        if (this.options[pNetwork].data.netmask != pData.netmask) {
          this.options[pNetwork].data.netmask = pData.netmask;
          needUpdate = true;
        }

        if (this.options.GATEWAY.data.gateway != pData.gateway) {
          this.options.GATEWAY.data.gateway = pData.gateway;
          needUpdate = true;
        }

        // cancel the ui update if we are editing
        if (editing) {
          needUpdate = false;
        }
        break;
      }
      default:
        console.error('Network-page: not supported setting,', pType, pData);
        break;
    }

    if (needUpdate) { this.show(); }
  },
};

export default networkApp;
